import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getProjectById({ commit, state }, { id }) {
    try {
      let project = (state.projects || []).find((p) => p.id === id);
      if (!project) {
        let response = await requestAxios({
          url: `/awy/api/v1/projects/${id}`,
          method: "GET",
        });

        project = response.data.data;
      }

      commit(MutationsType.SET_PROJECT, project);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllProjects({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/projects",
        method: "GET",
      });

      commit(MutationsType.SET_PROJECTS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveProject({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/projects",
        method: "POST",
        data: data,
      });

      commit(MutationsType.ADD_PROJECT, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateProject({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/projects/${id}`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_PROJECT, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updatePortionsPerAgent({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/projects/${id}/portions-per-agent`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_PROJECT, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetProject({ commit }) {
    commit(MutationsType.SET_PROJECT, null);
  },
  resetModuleProject({ commit }) {
    commit(MutationsType.SET_PROJECT, null);
    commit(MutationsType.SET_PROJECTS, null);
  },
};
